import { createSlice } from '@reduxjs/toolkit';
import { WebStorageClient } from "../clients/webStorage.client";
import { WEB_STORAGE_KEYS } from "../clients/clients.constants";

const initialOptions = {
  siteId: ''
};

const initialState = WebStorageClient.getByKey('site_id') || initialOptions;

const siteIdSlice = createSlice({
  name: 'siteId',
  initialState,
  reducers: {
    setSiteId(state, action) {
      state.siteId = action.payload;
    },
  },
});

export const { setSiteId } = siteIdSlice.actions;

export default siteIdSlice.reducer;